module.exports = __webpack_public_path__ + "img/full3-min.d61d1a6d.png";